import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e53edd16"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "overlay-background"
}
const _hoisted_2 = { class: "user-edit-card" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Edit Employee Details", -1))
const _hoisted_4 = { class: "toggle-switch" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "editToggle",
  class: "switch"
}, null, -1))
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "username" }, "Username", -1))
const _hoisted_8 = ["readonly"]
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "firstName" }, "First Name", -1))
const _hoisted_11 = ["readonly"]
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "lastName" }, "Last Name", -1))
const _hoisted_14 = ["readonly"]
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email", -1))
const _hoisted_17 = ["readonly"]
const _hoisted_18 = {
  key: 0,
  class: "form-group"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "hourlyPay" }, "Hourly Pay", -1))
const _hoisted_20 = ["readonly"]
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "dateJoined" }, "Date of Joining", -1))
const _hoisted_23 = ["readonly"]
const _hoisted_24 = {
  key: 1,
  class: "checkbox-group"
}
const _hoisted_25 = ["disabled"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "isSuperuser" }, "Is Admin", -1))
const _hoisted_27 = ["disabled"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "isStaff" }, "Is Manager", -1))
const _hoisted_29 = ["disabled"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "isActive" }, "Is Active", -1))
const _hoisted_31 = {
  key: 2,
  type: "submit"
}
const _hoisted_32 = {
  key: 1,
  class: "loading-container"
}

import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useEmployeeStore } from '@/stores/UserEmployee';
import { useUserStore } from '@/stores/UserStore';
import { fetchEmployeeById } from '@/api/api';
import { patchToUrl, fetchWorkCenters as fetchWorkCentersApi } from '@/api/api';

interface UserEmployee {
  id: number | null;
  username: string;
  first_name: string;
  last_name: string;
  email: string;
  date_joined: Date | string;
  is_staff: boolean;
  is_active: boolean;
  is_superuser: boolean;
  hourly_pay: number | null;
  work_center: number | string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EditEmployeeDetails',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const employeeStore = useEmployeeStore();
const userStore = useUserStore();
const employeeData = ref(null);
const isEditing = ref(false);
const isLoading = ref(true);


const employee = ref<UserEmployee>({
  id: null,
  username: '',
  first_name: '',
  last_name: '',
  email: '',
  date_joined: '',
  hourly_pay: null,
  work_center: '',
  is_staff: false,
  is_active: false,
  is_superuser: false,
});

const navigateBack = () => {
  const userEmployeeId = Number(route.params.userEmployeeId);
  if (userEmployeeId) {
    router.push({ name: 'employeeDetail', params: { userEmployeeId } });
  } else {
    console.error('UserEmployee ID is missing');
  }
};

const workCenters = ref([]);

const fetchWorkCenters = async () => {
  workCenters.value = await fetchWorkCentersApi();
};

onMounted(async () => {
  await fetchEmployeeDetails();
  await fetchWorkCenters();
});

const toggleEditing = () => {
  isEditing.value = !isEditing.value;
};


const fetchEmployeeDetails = async () => {
  const userEmployeeId = Number(route.params.userEmployeeId);
  if (!userEmployeeId) {
    console.error("Invalid or missing employee ID");
    return;
  }

  try {
    await employeeStore.fetch();
    const fetchedEmployee = employeeStore.getById(userEmployeeId);

    if (fetchedEmployee) {
      const hourlyPay = fetchedEmployee.hourly_pay || null;
      const workCenterId = fetchedEmployee.work_center?.id || null;

      employee.value = {
        ...employee.value,
        id: fetchedEmployee.user.id,
        username: fetchedEmployee.user.username,
        first_name: fetchedEmployee.user.first_name,
        last_name: fetchedEmployee.user.last_name,
        email: fetchedEmployee.user.email,
        date_joined: formatDate(fetchedEmployee.user.date_joined),
        hourly_pay: hourlyPay,
        work_center: workCenterId,
        is_staff: Boolean(fetchedEmployee.user.is_staff),
        is_active: Boolean(fetchedEmployee.user.is_active),
        is_superuser: Boolean(fetchedEmployee.user.is_superuser),
      };
    } else {
      console.error('Employee not found');
    }
  } catch (error) {
    console.error('Error fetching employee details:', error);
  } finally {
    isLoading.value = false;
  }
};

const findWorkCenterName = (workCenterId) => {
  const center = workCenters.value.find(c => c.id === workCenterId);
  return center ? center.name : 'Not Assigned';
};


const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return date.toISOString().split('T')[0];
};

const saveEmployeeDetails = async () => {
  console.log('Employee data:', employee.value);

  if (!employee.value.id) {
    console.error('Employee ID is undefined:', employee.value);
    alert("Employee ID is not found.");
    return;
  }

  try {
    const url = `/ops/api/Updateuser/${employee.value.id}/`;
    const updatedUserData = {
      username: employee.value.username,
      first_name: employee.value.first_name,
      last_name: employee.value.last_name,
      email: employee.value.email,
      date_joined: employee.value.date_joined,
      is_superuser: employee.value.is_superuser,
      is_staff: employee.value.is_staff,
      is_active: employee.value.is_active,
      hourly_pay: employee.value.hourly_pay,
      work_center: employee.value.work_center,
    };

    console.log('Sending request to backend to update user...');
    const response = await patchToUrl(url, updatedUserData);

    if (response && response.id) {
      console.log('User update successful.');
      alert("User updated successfully.");
      isEditing.value = false;

    } else {
      console.error('User update failed with response:', response);
      alert("Failed to update user. Please check the provided data.");
    }
  } catch (error) {
    console.error('Error updating user:', error);
    alert("Failed to update user. Error: " + error.message);
  }
};

onMounted(fetchEmployeeDetails);


return (_ctx: any,_cache: any) => {
  return (!isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "close-button",
            onClick: navigateBack
          }, "✕"),
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              id: "editToggle",
              type: "checkbox",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isEditing).value = $event))
            }, null, 512), [
              [_vModelCheckbox, isEditing.value]
            ]),
            _hoisted_5
          ]),
          _createElementVNode("form", {
            onSubmit: _withModifiers(saveEmployeeDetails, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                id: "username",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((employee.value.username) = $event)),
                readonly: !isEditing.value,
                type: "text"
              }, null, 8, _hoisted_8), [
                [_vModelText, employee.value.username]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createElementVNode("input", {
                id: "firstName",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((employee.value.first_name) = $event)),
                readonly: !isEditing.value,
                type: "text"
              }, null, 8, _hoisted_11), [
                [_vModelText, employee.value.first_name]
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _withDirectives(_createElementVNode("input", {
                id: "lastName",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((employee.value.last_name) = $event)),
                readonly: !isEditing.value,
                type: "text"
              }, null, 8, _hoisted_14), [
                [_vModelText, employee.value.last_name]
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _withDirectives(_createElementVNode("input", {
                id: "email",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((employee.value.email) = $event)),
                readonly: !isEditing.value,
                type: "email"
              }, null, 8, _hoisted_17), [
                [_vModelText, employee.value.email]
              ])
            ]),
            (_unref(employeeStore).currentUser.user?.is_superuser)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _hoisted_19,
                  _withDirectives(_createElementVNode("input", {
                    id: "hourlyPay",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((employee.value.hourly_pay) = $event)),
                    readonly: !isEditing.value,
                    type: "number",
                    step: "0.01"
                  }, null, 8, _hoisted_20), [
                    [_vModelText, employee.value.hourly_pay]
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _withDirectives(_createElementVNode("input", {
                id: "dateJoined",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((employee.value.date_joined) = $event)),
                readonly: !isEditing.value,
                type: "date"
              }, null, 8, _hoisted_23), [
                [_vModelText, employee.value.date_joined]
              ])
            ]),
            (_unref(employeeStore).currentUser.user?.is_superuser)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "isSuperuser",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((employee.value.is_superuser) = $event)),
                    disabled: !isEditing.value
                  }, null, 8, _hoisted_25), [
                    [_vModelCheckbox, employee.value.is_superuser]
                  ]),
                  _hoisted_26,
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "isStaff",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((employee.value.is_staff) = $event)),
                    disabled: !isEditing.value
                  }, null, 8, _hoisted_27), [
                    [_vModelCheckbox, employee.value.is_staff]
                  ]),
                  _hoisted_28,
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "isActive",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((employee.value.is_active) = $event)),
                    disabled: !isEditing.value
                  }, null, 8, _hoisted_29), [
                    [_vModelCheckbox, employee.value.is_active]
                  ]),
                  _hoisted_30
                ]))
              : _createCommentVNode("", true),
            (isEditing.value)
              ? (_openBlock(), _createElementBlock("button", _hoisted_31, "Save"))
              : _createCommentVNode("", true)
          ], 32)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_32))
}
}

})